export function findTopLevelNavObjectByPath(navArray, targetPath) {
  for (const item of navArray) {
    // 检查当前项的path属性是否匹配
    // if (item.path === targetPath) {
    if (targetPath.includes(item.path)) {
      return item
    }
    // 如果有children属性，递归搜索
    if (item.children) {
      const foundItem = findTopLevelNavObjectByPath(item.children, targetPath)
      if (foundItem) {
        return item
      }
    }
  }
  return null
}

export function removeDetails(navArray) {
  // 深拷贝 清除副作用
  const arr = JSON.parse(JSON.stringify(navArray))
  // 过滤函数，递归删除包含'detail'的项
  function filterArray(array) {
    return array.filter(item => {
      // 如果当前项的path包含'detail'，则删除该项
      if (item.path.includes('detail')) {
        return false
      }
      // 如果有children属性，递归过滤
      if (item.children && item.children.length > 0) {
        item.children = filterArray(item.children) // 递归过滤子项
      }
      return true
    })
  }

  // 开始递归过滤
  return filterArray(arr)
}
